import React, { useState } from "react";
import { useStyles } from "./rightBar.styles";

import squareImg from "../../assets/svgs/Square.svg";
import { Link } from 'react-scroll';

function RightBar() {

  const styles = useStyles();
  const [activeSection, setActiveSection] = useState(null);
  const sections = ["Home", "About", "Skills", "Projects", "Contact"];

  const handleSetActive = (section) => {
    setActiveSection(section);
  };

  return (
    <div className={styles.main}>
      {sections.map((section) => {

        const isActive = activeSection === section;
        const imageStyle = isActive ? { transform: "rotate(45deg)", backgroundColor: "black" } : {};

        return (
          <div key={section}>
            <Link
              to={section}
              spy={true}
              smooth={true}
              offset={-100}
              duration={1000}
              onSetActive={() => handleSetActive(section)}
            >
              <img
                id={section}
                src={squareImg}
                style={imageStyle}
                alt={section}
              />
            </Link>
          </div>
        );
      })}

      <span className="vertical-line" />
    </div>
  );

}

export default RightBar;
